// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3fsfI","form":"styles_form__3OUhI"};